import { React, useState } from "react";
import styled from '@emotion/styled'
import * as Const from "./const.js"
import CarltonFace from '../img/carlton-face.png'
import { Children } from "react";

const Button = styled.button`
    height: 55px;
    align-items: flex-start;    
    background-color: #282828;
    color: ${Const.linkColor};
    width: auto;
    border-radius: 5px;
    border: 1px solid ${Const.linkColor};
    font-size: 1em;
    display: inline-block;
    cursor: pointer;
    font-family: monospace, 'Courier New';

    &:hover {
        background-color: ${Const.linkColor};
        color: #000;
    }
  

    ${Const.mq[0]} {
        position: fixed;
        bottom: 20px;
        width: 90%;
        align-self: center;
        justify-self: flex-end !important;
    }
`

const PrimaryButton = ({children, onClick}) => {

    return(
        <Button onClick={onClick}>
            {children}
        </Button>
    )

}

export default PrimaryButton